/* eslint-disable max-len */
/* eslint-disable import-helpers/order-imports */
/* eslint-disable implicit-arrow-linebreak */
import React, {
  useState, useEffect, useContext, useCallback, useRef,
} from 'react';
import {
  Card,
  Container,
  Row,
  Col,
  CardHeader,
  CardBody,
  Button,
  Progress,
  FormGroup,
  Input,
  Label,
  Table,
} from 'reactstrap';
import { format } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';

import DatePickerMaskedInput from '../../components/DatePickerMaskedInput';
import GoToTop from '../../components/GoToTop';
import Notification from '../../components/Notification';
import Select from '../../components/Select';
import { AppContext } from '../../contexts/app';
import usePresencaTotal from '../../hooks/usePresencaTotal';
import useUsuariosOnline from '../../hooks/useUsuariosOnline';
import LayoutAdmin from '../../layouts/admin';
import api from '../../services/api';

const indicadorStyle = {
  height: '75px',
  width: '100%',
  maxWidth: '450px',
  fontSize: '2rem',
  fontWeight: 'bold',
  borderRadius: '0.75rem',
  marginTop: '0.75rem',
  cursor: 'default',
};

const SITUACAO_OPTIONS = [
  { value: 'PRESENTE', label: 'PRESENTE' },
  { value: 'FALTOU', label: 'FALTOU' },
  { value: 'JUSTIFICADO', label: 'JUSTIFICADO' },
  { value: 'LICENCIADO', label: 'LICENCIADO' },
  { value: 'RENUNCIOU', label: 'RENUNCIOU' },
  { value: 'PERDEUOCARGO', label: 'PERDEU O CARGO' },
];

const STATUS_LABELS = {
  processando: 'Em Andamento',
  pronto: 'Pronto Download',
  erro: 'Não Disponível',
  indisponivel: 'Não Disponível',
};

const formatDatePayload = (date) => (date ? format(date, 'yyyy-MM-dd') : null);

const formatDisplayDate = (value) => {
  if (!value) {
    return '-';
  }

  return format(new Date(value), 'dd/MM/yyyy HH:mm', { locale: ptBR });
};

const SESSOES_TODAS = [{ label: 'TODAS', value: null }];

const sessaoMatchesTipo = (sessao, tipo) => {
  switch (tipo) {
    case 'presencial':
      return sessao.is_presencial;
    case 'hibrida':
      return !sessao.is_presencial;
    case 'ordinaria':
      return sessao.is_ordinaria;
    case 'posse':
      return sessao.is_posse;
    default:
      return false;
  }
};

const sessaoMatchesAnyTipo = (sessao, tiposSelecionados) =>
  tiposSelecionados.some((tipo) => sessaoMatchesTipo(sessao, tipo));

const filterSessoesByTipos = (sessoesList, tiposSelecionados) =>
  (tiposSelecionados.length
    ? sessoesList.filter((s) => sessaoMatchesAnyTipo(s, tiposSelecionados))
    : sessoesList);

export default function RelatorioPresencaAdminNovo() {
  const notificationRef = useRef();
  const { setLoading } = useContext(AppContext);

  const [mandatoDe, setMandatoDe] = useState(null);
  const [mandatoAte, setMandatoAte] = useState(null);
  const [sessaoRapida, setSessaoRapida] = useState(null);
  const [ativo, setAtivo] = useState(-1);
  const [tipos, setTipos] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([{ label: 'TODOS', value: null }]);
  const [selectedSituacoes, setSelectedSituacoes] = useState([{ label: 'TODOS', value: null }]);
  const [users, setUsers] = useState([]);
  const [sessoes, setSessoes] = useState([]);
  const [listSessoes, setListSessoes] = useState([]);
  const [sessoesFilter, setSessoesFilter] = useState(SESSOES_TODAS);
  const [solicitacoes, setSolicitacoes] = useState([]);
  const [activeSolicitacao, setActiveSolicitacao] = useState(null);
  const [generating, setGenerating] = useState(false);
  const usuariosOnline = useUsuariosOnline();
  const presencaTotal = usePresencaTotal(sessaoRapida?.value);

  const loadSolicitacoes = useCallback(async () => {
    try {
      const { data } = await api.get('/relatorioPresencaAdmin/solicitacoes');
      setSolicitacoes(data || []);

      const processing = (data || []).find((item) => item.status === 'processando');
      setActiveSolicitacao(processing || null);
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const [sessoesResult, usersResult] = await Promise.allSettled([
          api.get('/sessoes'),
          api.get('/users?size=0'),
        ]);

        if (sessoesResult.status === 'fulfilled') {
          setSessoes(
            sessoesResult.value.data
              .filter((d) => !d.is_teste)
              .map((d) => ({
                ...d,
                value: d.id,
                label: `${d.id} - ${d.nome}`,
              })),
          );
        } else {
          console.error(sessoesResult.reason);
        }

        if (usersResult.status === 'fulfilled') {
          setUsers(usersResult.value.data.map((d) => ({
            label: `${d.name} - ${d.email} - ${d.cim} - ${d.uf_loja || d.uf || 'S/UF'}`,
            value: d.id,
          })));
        } else {
          console.error(usersResult.reason);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [setLoading]);

  useEffect(() => {
    loadSolicitacoes();
  }, [loadSolicitacoes]);

  useEffect(() => {
    if (!activeSolicitacao) {
      return undefined;
    }

    const timer = setInterval(loadSolicitacoes, 3000);
    return () => clearInterval(timer);
  }, [activeSolicitacao, loadSolicitacoes]);

  useEffect(() => {
    if (!sessoes.length) {
      return;
    }

    if (!tipos.length) {
      setListSessoes(sessoes);
      setSessoesFilter(SESSOES_TODAS);
      return;
    }

    const matching = filterSessoesByTipos(sessoes, tipos);
    setListSessoes(matching);
    setSessoesFilter(matching.length ? matching : SESSOES_TODAS);
  }, [tipos, sessoes]);

  const handleSelectedUser = useCallback((newSelectedUsers) => {
    setSelectedUsers(() => (!newSelectedUsers?.length
      ? [{ label: 'TODOS', value: null }]
      : newSelectedUsers.filter((u) => u.value)));
  }, []);

  const handleSelectedSituacoes = useCallback((newSelectedSituacoes) => {
    setSelectedSituacoes(() => (!newSelectedSituacoes?.length
      ? [{ label: 'TODOS', value: null }]
      : newSelectedSituacoes.filter((s) => s.value)));
  }, []);

  const handleSelectedSession = useCallback((newSelectedSessions) => {
    const filtered = newSelectedSessions?.filter((s) => s.value) || [];

    if (!filtered.length) {
      setSessoesFilter(SESSOES_TODAS);
      return;
    }

    if (tipos.length) {
      const allowedIds = new Set(filterSessoesByTipos(sessoes, tipos).map((s) => s.value));
      const valid = filtered.filter((s) => allowedIds.has(s.value));
      setSessoesFilter(valid.length ? valid : SESSOES_TODAS);
      return;
    }

    setSessoesFilter(filtered);
  }, [tipos, sessoes]);

  const handleSessaoRapida = useCallback((selected) => {
    setSessaoRapida(selected);

    if (selected?.value) {
      const match = sessoes.find((s) => s.value === selected.value);
      setSessoesFilter(match ? [match] : SESSOES_TODAS);
    } else {
      setSessoesFilter(SESSOES_TODAS);
    }
  }, [sessoes]);

  const buildPayload = useCallback(() => ({
    mandatoDe: formatDatePayload(mandatoDe),
    mandatoAte: formatDatePayload(mandatoAte),
    tiposSessao: tipos,
    sessaoIds: sessoesFilter.filter((s) => s.value).map((s) => s.value),
    userIds: selectedUsers.filter((u) => u.value).map((u) => u.value),
    ativo,
    situacoes: selectedSituacoes.filter((s) => s.value).map((s) => s.value),
  }), [mandatoDe, mandatoAte, tipos, sessoesFilter, selectedUsers, ativo, selectedSituacoes]);

  const handleGerarRelatorio = useCallback(async () => {
    try {
      setGenerating(true);
      const { data } = await api.post('/relatorioPresencaAdmin/solicitacoes', buildPayload());

      notificationRef.current?.notify({
        message: 'Solicitação de relatório registrada.',
        color: 'success',
      });

      setActiveSolicitacao(data);
      await loadSolicitacoes();
    } catch (error) {
      console.error(error);
      notificationRef.current?.notify({
        message: 'Não foi possível iniciar a geração do relatório.',
        color: 'danger',
      });
    } finally {
      setGenerating(false);
    }
  }, [buildPayload, loadSolicitacoes]);

  const handleDownload = useCallback(async (solicitacao) => {
    try {
      setLoading(true);
      const { data } = await api.get(
        `/relatorioPresencaAdmin/solicitacoes/${solicitacao.id}/download`,
        { responseType: 'blob' },
      );

      const url = URL.createObjectURL(data);
      const link = document.createElement('a');
      link.href = url;
      link.download = `relatorio-presenca-${solicitacao.id}.zip`;
      link.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      notificationRef.current?.notify({
        message: 'Não foi possível baixar o relatório.',
        color: 'danger',
      });
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  const toggleTipo = (tipo) => {
    setTipos((prev) => (prev.includes(tipo)
      ? prev.filter((t) => t !== tipo)
      : [...prev, tipo]));
  };

  const progressoAtivo = activeSolicitacao?.progresso || 0;
  const mensagemAtiva = activeSolicitacao?.mensagem || '';

  return (
    <LayoutAdmin>
      <Notification ref={notificationRef} />
      <Container>
        <GoToTop />
        <Row>
          <Col>
            <Card className="mt-5">
              <CardHeader>
                <h2>Relatório de Presença (Novo)</h2>
              </CardHeader>
            </Card>

            <Row className="mt-3">
              <Col>
                <Card>
                  <CardHeader>Sessão</CardHeader>
                  <CardBody>
                    <Select
                      placeholder="Selecione uma Sessão"
                      value={sessaoRapida}
                      options={sessoes}
                      isClearable
                      onChange={handleSessaoRapida}
                    />
                    {sessaoRapida && sessaoRapida.value ? (
                      <>
                        <Button
                          color="primary"
                          style={indicadorStyle}
                          tabIndex={-1}
                        >
                          {presencaTotal == null
                            ? '... Presenças'
                            : `${presencaTotal} Presenças`}
                        </Button>
                        <Button
                          color="primary"
                          style={{
                            ...indicadorStyle,
                            marginTop: 0,
                          }}
                          tabIndex={-1}
                        >
                          {usuariosOnline == null
                            ? '... Online'
                            : `${usuariosOnline} Online`}
                        </Button>
                      </>
                    ) : null}
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col>
                <Card>
                  <CardHeader>Relatório Detalhado</CardHeader>
                  <CardBody>
                    <Row>
                      <Col xs={12} sm={8}>
                        <Row>
                          <Col xs={2}>
                            <strong>Período:</strong>
                          </Col>
                          <Col xs={10} tag="div" className="d-flex">
                            <DatePickerMaskedInput
                              placeholderText="Início de Mandato"
                              selected={mandatoDe}
                              open={false}
                              startOpen={false}
                              isClearable
                              onChange={(date) => setMandatoDe(date)}
                            />
                            <span className="ml-3 mr-3 mt-2">a</span>
                            <DatePickerMaskedInput
                              placeholderText="Fim de Mandato"
                              selected={mandatoAte}
                              open={false}
                              startOpen={false}
                              isClearable
                              onChange={(date) => setMandatoAte(date)}
                            />
                          </Col>
                        </Row>
                        <Row className="mt-2">
                          <Col xs={2}>
                            <strong>Sessão:</strong>
                          </Col>
                          <Col xs={10} tag="div" className="d-flex flex-wrap">
                            <FormGroup check className="mr-3">
                              <Input
                                type="checkbox"
                                checked={tipos.includes('presencial')}
                                onChange={() => toggleTipo('presencial')}
                              />
                              <Label check>Presencial</Label>
                            </FormGroup>
                            <FormGroup check className="mr-3">
                              <Input
                                type="checkbox"
                                checked={tipos.includes('hibrida')}
                                onChange={() => toggleTipo('hibrida')}
                              />
                              <Label check>Híbrida</Label>
                            </FormGroup>
                            <FormGroup check className="mr-3">
                              <Input
                                type="checkbox"
                                checked={tipos.includes('ordinaria')}
                                onChange={() => toggleTipo('ordinaria')}
                              />
                              <Label check>Ordinária</Label>
                            </FormGroup>
                            <FormGroup check className="mr-3">
                              <Input
                                type="checkbox"
                                checked={tipos.includes('posse')}
                                onChange={() => toggleTipo('posse')}
                              />
                              <Label check>Posse</Label>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row className="mt-2">
                          <Col xs={2} />
                          <Col xs={10}>
                            <Select
                              placeholder="Escolha uma ou mais sessões"
                              value={sessoesFilter}
                              options={listSessoes}
                              isMulti
                              isClearable={false}
                              onChange={handleSelectedSession}
                            />
                          </Col>
                        </Row>
                        <Row className="mt-2">
                          <Col xs={2}>
                            <strong>Deputado:</strong>
                          </Col>
                          <Col xs={10}>
                            <Select
                              placeholder="Escolha um ou mais deputados"
                              value={selectedUsers}
                              options={users}
                              onChange={handleSelectedUser}
                              isMulti
                            />
                          </Col>
                        </Row>
                        <Row className="mt-2">
                          <Col xs={2}>
                            <strong>Status:</strong>
                          </Col>
                          <Col xs={10} tag="div" className="d-flex">
                            <FormGroup check className="mr-3">
                              <Input
                                type="radio"
                                checked={ativo === -1}
                                onChange={() => setAtivo(-1)}
                              />
                              <Label check>Todos</Label>
                            </FormGroup>
                            <FormGroup check className="mr-3">
                              <Input
                                type="radio"
                                checked={ativo === 1}
                                onChange={() => setAtivo(1)}
                              />
                              <Label check>Somente Ativos</Label>
                            </FormGroup>
                            <FormGroup check className="mr-3">
                              <Input
                                type="radio"
                                checked={ativo === 0}
                                onChange={() => setAtivo(0)}
                              />
                              <Label check>Somente Inativos</Label>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row className="mt-2">
                          <Col xs={2}>
                            <strong>Situação:</strong>
                          </Col>
                          <Col xs={10}>
                            <Select
                              placeholder="Escolha uma ou mais situações"
                              value={selectedSituacoes}
                              options={SITUACAO_OPTIONS}
                              onChange={handleSelectedSituacoes}
                              isMulti
                            />
                          </Col>
                        </Row>
                        {activeSolicitacao && (
                          <>
                            <Row className="mt-3">
                              <Col>
                                <span style={{ fontSize: '0.75rem' }}>
                                  {mensagemAtiva}
                                </span>
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                <Progress
                                  color={progressoAtivo < 100 ? 'primary' : 'success'}
                                  value={progressoAtivo}
                                >
                                  {`${progressoAtivo} %`}
                                </Progress>
                              </Col>
                            </Row>
                          </>
                        )}
                      </Col>
                      <Col xs={12} sm={4}>
                        <Button
                          color="primary"
                          onClick={handleGerarRelatorio}
                          disabled={generating || !!activeSolicitacao}
                          style={{
                            height: '75px',
                            fontWeight: 'bold',
                            borderRadius: '0.75rem',
                          }}
                          block
                        >
                          Gerar Relatório
                        </Button>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col>
                <Card>
                  <CardHeader>Histórico de Solicitações</CardHeader>
                  <CardBody>
                    <Table bordered responsive>
                      <thead>
                        <tr>
                          <th>Tipo Relatório</th>
                          <th>Data Solicitado</th>
                          <th>Status</th>
                          <th>Ação</th>
                        </tr>
                      </thead>
                      <tbody>
                        {solicitacoes.length === 0 && (
                          <tr>
                            <td colSpan={4} className="text-center text-muted">
                              Nenhuma solicitação registrada.
                            </td>
                          </tr>
                        )}
                        {solicitacoes.map((item) => (
                          <tr key={item.id}>
                            <td>Presença</td>
                            <td>{formatDisplayDate(item.created_at)}</td>
                            <td>{STATUS_LABELS[item.status] || item.status}</td>
                            <td>
                              <Button
                                color="primary"
                                size="sm"
                                disabled={item.status !== 'pronto'}
                                onClick={() => handleDownload(item)}
                              >
                                Baixar
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </LayoutAdmin>
  );
}
